import { cx } from '@emotion/css';
import { getDesignSystemIcon } from '@phoenix/design-system/frontend/util/path.utils';
import { useTranslation } from 'next-i18next';
import { FC } from 'react';
import { Asset } from '../../domain/static-content/static-assets-api.model';

const logo = getDesignSystemIcon('stihl_logo.svg');

interface Props {
  assets: Asset[];
}

export const UnsupportedBrowser: FC<React.PropsWithChildren<Props>> = ({ assets }) => {
  const { t } = useTranslation('shared');

  const image = assets?.find((asset) => 'grass.svg' === asset.fileName);

  return (
    <div
      className={cx(`flex min-h-screen w-full flex-col bg-cover bg-center p-6 mobileOnly:p-0`)}
      style={{
        backgroundImage: `url(${image?.url}?q=75&fm=jpg)`,
      }}
    >
      <div className="flex flex-row-reverse">
        <img src={logo} alt="Stihl logo" className="ml-auto h-16" />
      </div>

      <div className="flex flex-grow items-center justify-center mobileOnly:mt-8 mobileOnly:items-start">
        <div className="w-[40.625rem] bg-primary-white p-8 mobileOnly:w-[17.5rem] mobileOnly:p-6">
          <p className="stihl-text-h1-desktop mobileOnly:stihl-text-h4-mobile">
            {t('shared_errorpage_browserNotSupported_content_headline')}
          </p>
          <p className="mt-4 whitespace-pre-line stihl-text-body-default-reg">
            {t('shared_errorpage_browserNotSupported_content_copyText')}
          </p>
        </div>
      </div>
    </div>
  );
};
